module.exports = __webpack_public_path__ + "img/CameraZOOM-20210712092113909.989cee63.jpg";